import React, { useEffect, useState } from "react";
import ManagerDashboardWapper from "../../../layout/wrapper/ManagerDashboardWapper";
import { Box, List, ListItem, Paper, Stack, Typography } from "@mui/material";
import styles from "../../../styles/pages/user/managerdashboard/manager-dashboard-searchresult.module.scss";
import Search01 from "../../../public/assets/images/s01.jpg";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import Magnifying from "../../../public/assets/images/icon-magnifying.svg";
import { useAppSelector } from "../../../hooks/useAppSelector";
import { useQuery } from "react-query";
import { searchDataCall } from "../../../api/functions/user.api";
import useFetch from "../../../hooks/api/useFetch";
import {
  getAbsoluteImageURI,
  getStyledDateTime,
  getUtcDate,
  getUtcTime,
} from "../../../lib/functions/utils.lib";
import InfiniteScroll from "react-infinite-scroll-component";
import { useInfiniteFetch } from "../../../hooks/api/useInfiniteFetch";
import { Fragment } from "react";

function videoStatus(item) {
  if (
    item?.status === 0 &&
    item?.manager_decision === 0 &&
    item?.admin_decision === 0 &&
    item?.quality_team_decision === 0
  ) {
    return "Video pending Reviewing";
  } else if (
    item?.manager_decision !== 0 &&
    item?.quality_team_decision === 0
  ) {
    return "video Awaiting confirmation";
  } else if (item?.video_meta?.revision_requested_at === 1) {
    return "Metadata Revision Requested";
  } else if (item?.video_meta?.new_title === null && item?.status === 1) {
    return "Video Pending Titling";
  } else if (
    item?.video_meta?.copywrite_completed === 1 &&
    item?.published === 0
  ) {
    return "Video Pending Publication";
  } else {
    return null;
  }
}

function videoDate(item) {
  if (
    item?.status === 0 &&
    item?.manager_decision === 0 &&
    item?.admin_decision === 0 &&
    item?.quality_team_decision === 0
  ) {
    return `Since ${getUtcDate(item?.created_at)}${getUtcTime(
      item?.created_at
    )}`;
  } else if (
    item?.manager_decision !== 0 &&
    item?.quality_team_decision === 0
  ) {
    return `Since ${getUtcDate(
      item?.video_meta?.manager_updated_at
    )}${getUtcTime(item?.video_meta?.manager_updated_at)}`;
  } else if (item?.video_meta?.revision_requested_at === 1) {
    return `Since ${getUtcDate(
      item?.video_meta?.revision_requested_at
    )}${getUtcTime(item?.video_meta?.revision_requested_at)}`;
  } else if (item?.video_meta?.new_title === null && item?.status === 1) {
    return item?.status_changed_at
      ? `Since ${getUtcDate(item?.status_changed_at)}${getUtcTime(
          item?.status_changed_at
        )}`
      : null;
  } else if (item?.status === 2) {
    return item?.status_changed_at
      ? `Video Rejected on ${getUtcDate(item?.status_changed_at)}${getUtcTime(
          item?.status_changed_at
        )}`
      : null;
  } else if (item?.status === 6) {
    return item?.video_meta?.duplicate_marked_at
      ? `Video Flagged as Duplicate on ${getUtcDate(
          item?.video_meta?.duplicate_marked_at
        )}${getUtcTime(item?.video_meta?.duplicate_marked_at)}`
      : null;
  } else if (
    item?.video_meta?.copywrite_completed === 1 &&
    item?.published === 0
  ) {
    return `Since ${getUtcDate(
      item?.video_meta?.copywrite_completed_at
    )}${getUtcTime(item?.video_meta?.copywrite_completed_at)}`;
  } else if (item?.publshed === 1) {
    return item?.published_at
      ? `Video Published on ${getUtcDate(item?.published_at)}${getUtcTime(
          item?.published_at
        )}`
      : null;
  } else {
    return null;
  }
}

function videoColorType(item) {
  if (
    item?.status === 0 &&
    item?.manager_decision === 0 &&
    item?.admin_decision === 0 &&
    item?.quality_team_decision === 0
  ) {
    return styles.bgLightOrng;
  } else if (
    item?.manager_decision !== 0 &&
    item?.quality_team_decision === 0
  ) {
    return styles.bgLightgray;
  } else if (item?.video_meta?.revision_requested_at === 1) {
    return styles.bgGreen;
  } else if (item?.video_meta?.new_title === null && item?.status === 1) {
    return styles.bgGreen;
  } else if (
    item?.video_meta?.copywrite_completed === 1 &&
    item?.published === 0
  ) {
    return styles.bgLightsky;
  } else if (item?.status === 2) {
    return styles.bgLightred;
  } else if (item?.status === 6) {
    return styles.bgDarkgray;
  } else if (item?.publshed === 1) {
    return styles.bgLightsky;
  } else {
    return null;
  }
}
export default function SearchResult() {
  const { query } = useAppSelector((s) => s.searchQuerySlice);

  const [previousData, setPreviousData] = useState(null);
  const [searchData, setSearchData] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleMouseEnter = (index) => {
    setHoveredIndex(index - 1);
  };

  const handleMouseLeave = () => {
    setHoveredIndex(null);
  };

  const { data, fetchNextPage, hasNextPage, refetch, isLoading } =
    useInfiniteFetch(
      ["manager-search", query],
      `manager/videos?search=${query}`
    );

  useEffect(() => {
    if (data) {
      setPreviousData(data);
      setSearchData(query);
    }
  }, [data]);
  console.warn(data);
  return (
    <>
      <ManagerDashboardWapper>
        <Box className={styles.searchBodymid}>
          {query?.length && data?.pages?.length ? (
            <>
              <Stack
                direction={"row"}
                alignItems={"center"}
                flexWrap={"wrap"}
                className={styles.showResult}
              >
                <Typography variant="body1">
                  Search results for “{query}”
                </Typography>
                <Typography variant="overlie">
                  {data?.pages?.[0]?.data?.total
                    ? data?.pages?.[0]?.data?.total
                    : 0}{" "}
                  results
                </Typography>
              </Stack>

              <InfiniteScroll
                dataLength={data?.pages?.length ? data?.pages?.length : 0}
                next={fetchNextPage}
                height={`calc(100vh - 159px)`}
                hasMore={hasNextPage}
                loader={<h4>Loading... </h4>}
                className={styles.scrollbodyPaper}
              >
                <Paper elevation={0} className={styles.paperSrchresult}>
                  {data?.pages?.map((group, groupIndex) => (
                    <Fragment key={groupIndex}>
                      {group?.data?.data?.map((item, index) => (
                        <Stack
                          direction={"row"}
                          alignItems={"flex-start"}
                          flexWrap={"wrap"}
                          className={`${styles.searchItem} ${
                            hoveredIndex === index ? `${styles.hover}` : ""
                          }`}
                          key={index}
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={handleMouseLeave}
                        >
                          <figure className={styles.mediaLeft}>
                            <img
                              src={getAbsoluteImageURI(item?.thumbnail)}
                              alt=""
                            />
                          </figure>
                          <Box className={styles.mediaRight}>
                            <List disablePadding>
                              <ListItem disablePadding>
                                <Typography variant="caption">VSID:</Typography>
                                <Typography variant="body1">
                                  {item?.vsid}
                                </Typography>
                              </ListItem>
                              <ListItem disablePadding>
                                <Typography variant="caption">
                                  Submission Date:
                                </Typography>
                                <Typography variant="body1">
                                  {getStyledDateTime(item?.created_at)}
                                </Typography>
                              </ListItem>
                              <ListItem
                                className={styles.submitterName}
                                disablePadding
                              >
                                <Typography variant="caption">
                                  Submitter Name:
                                </Typography>
                                <Typography variant="body1">
                                  {`${item?.name} ${item?.last_name}`}
                                </Typography>
                              </ListItem>
                              <ListItem disablePadding>
                                <Typography variant="caption">
                                  Email Address:
                                </Typography>
                                <Typography variant="body1">
                                  {item?.email}
                                </Typography>
                              </ListItem>
                              <ListItem disablePadding>
                                <Typography variant="caption">
                                  Acquisitor:
                                </Typography>
                                <Typography variant="body1">
                                  {`${item?.buyer?.name} ${item?.buyer?.last_name}`}{" "}
                                  <span className={styles.partner}>
                                    (
                                    {item?.buyer?.role?.display_name
                                      ? item?.buyer?.role?.display_name
                                      : "-"}
                                    )
                                  </span>
                                </Typography>
                              </ListItem>
                            </List>
                            {videoStatus(item) && videoDate(item) ? (
                              <Box
                                className={`${videoColorType(item)} ${
                                  styles.srchStatus
                                }`}
                              >
                                <Typography
                                  variant="body2"
                                  sx={{
                                    textTransform: "capitalize",
                                  }}
                                >
                                  {videoStatus(item)}
                                </Typography>
                                <Typography variant="body2">
                                  {videoDate(item)}
                                </Typography>
                              </Box>
                            ) : (
                              ""
                            )}
                          </Box>
                        </Stack>
                      ))}
                    </Fragment>
                  ))}
                </Paper>
              </InfiniteScroll>
            </>
          ) : (
            <Paper elevation={0} className={styles.nodataFound}>
              <figure>
                <img src={Magnifying} alt="" />
              </figure>
              <Typography variant="body1">
                We couldn't find any matching videos for{" "}
                <strong>{query}</strong>.
              </Typography>
            </Paper>
          )}
        </Box>
      </ManagerDashboardWapper>
    </>
  );
}
